import { makeAutoObservable } from 'mobx';
class WorkflowStore {
    documentId = null;
    docListNbr = null;
    documentPermissions = [];
    constructor() {
        makeAutoObservable(this);
    }
    setDocumentId = (id) => {
        this.documentId = id;
    };
    setDocListNbr = (docListNbr) => {
        this.docListNbr = docListNbr;
    };
    setDocumentPermissions = (documentPermissions) => {
        this.documentPermissions = documentPermissions;
    };
}
export default new WorkflowStore();
